// extracted by mini-css-extract-plugin
export default {"views":"views_views__rV4Um","sidebar":"views_sidebar__TrfKa","vaiShrinkSidebar":"views_vaiShrinkSidebar__jG6O+","content":"views_content__-x1LJ","errorPage":"views_errorPage__KXJed"};